export default __webpack_public_path__ + "static/muma-logo-adc57d78b7b3296a7f51862be82f3e5e.svg";